<template>

  <div class="height-100">
    <Unavailable
      v-if="unavailable"
      title="Campos customizados"
      class="height-100" />
    <div
      v-if="!unavailable"
      class="vflex">
      <div class="vflex-row-0 pt-3">
        <ul class="nav nav-tabs">
          <li class="nav-item pl-3">
            <a
              class="nav-link"
              :class="{active: modelType === 'job'}"
              href="javascript:void(0)"
              @click="changeModelType('job')">{{ $t('Job') }}</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{active: modelType === 'requisition'}"
              href="javascript:void(0)"
              @click="changeModelType('requisition')">{{ $t('Requisition') }}</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{active: modelType === 'candidate'}"
              href="javascript:void(0)"
              @click="changeModelType('candidate')">{{ $t('Candidate') }}</a>
          </li>
        </ul>
      </div>

      <div class="vflex-row-0 vflex-header p-3">
        <div class="page-title">
          <div class="title">
            <h4>{{ $t('Custom fields') }}</h4>
          </div>
          <div class="btn-row">
            <button
              type="button"
              class="btn btn-secondary"
              @click="showCreateGroupModal()">
              + {{ $t('New group') }}
              </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="showCreateCustomFieldModal()">
              +{{ $t('New field') }}
              </button>
          </div>
        </div>
      </div>

      <div class="vflex-row-1 p-3">

        <creating
          v-if="creating"
          height="100%" />

        <div
          v-if="!creating"
          :class="{'box-loading': loading}">

          <div 
            style="position: relative;" 
            v-if="customFieldGroups.length" 
            v-sortable="{handle: '.sortable-move', items: customFieldGroups, onUpdate: onGroupSortUpdate}">

            <div class="card mb-3" v-for="(group, index) in customFieldGroups">
              <div class="card-header">
                <a href="javascript:void(0)" class="sortable-move text-secondary"><i class="fas fa-arrows-alt" /></a>
                <a href="javascript:void(0)" @click="showEditGroupModal(group)">{{ group.name }}</a>
              </div>
              <ul class="list-group list-group-flush" v-sortable="{handle: '.move', items: group.custom_fields, onUpdate: onCustomFieldSortUpdate}">
                <li class="list-group-item" v-for="(field, customField_index) in group.custom_fields">
                  <a href="javascript:void(0)" class="move text-secondary"><i class="fas fa-arrows-alt" /></a>
                  <a href="javascript:void(0)" @click="showEditCustomFieldModal(field)">{{ field.label }}</a>
                </li>
              </ul>
            </div>

          </div>

          <no-results 
            v-if="!customFieldGroups.length">
            {{ $t('There are no items') }}
          </no-results>

        </div>
      </div>

      <div
        v-if="groupItemEdit"
        class="vflex-row-0">
        <custom-field-group-form 
          :initCustomFieldGroup="groupItemEdit"
          @hideModal="hideGroupModal()" 
          @deleted="loadData(); hideGroupModal()" 
          @saved="loadData(); hideGroupModal()">
          </custom-field-group-form>
      </div>

      <div
        v-if="customFieldItemEdit"
        class="vflex-row-0">
        <custom-field-form 
          :initCustomField="customFieldItemEdit"
          :modelType="modelType"
          @hideModal="hideCustomFieldModal()" 
          @deleted="loadData(); hideCustomFieldModal()" 
          @saved="loadData(); hideCustomFieldModal()">
          </custom-field-form>
      </div>
    </div>
  </div>

</template>

<script>
import CustomFieldGroupForm from './CustomFieldGroupForm'
import CustomFieldForm from './CustomFieldForm'
import Unavailable from '../Unavailable/Unavailable'

export default {
  name: 'CustomFieldGroup',
  components: {
    CustomFieldGroupForm,
    CustomFieldForm,
    Unavailable
  },
  data () {
    return {
      unavailable: false,
      creating: true,
      loading: true,
      groupItemEdit: false,
      customFieldItemEdit: false,
      modelType: 'job',
      customFieldGroups: []
    }
  },
  computed: {
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        sort: 'position',
        model_type: this.modelType
      }

      this.$store
      .dispatch('selectCustomFieldGroups', params)
      .then(result => {
        this.customFieldGroups = result
        this.loading = this.creating = false
      }).catch(err => {
        this.unavailable = err.response && err.response.data && err.response.data.name === 'UpgradeRequired'
      })
    },
    /*
    modal group
    */
    showCreateGroupModal () {
      this.groupItemEdit = {model_type: this.modelType}
    },
    showEditGroupModal (item) {
      this.groupItemEdit = this.$clone(item)
    },
    hideGroupModal () {
      this.groupItemEdit = false
    },
    /*
    modal customField
    */
    showCreateCustomFieldModal () {
      this.customFieldItemEdit = {model_type: this.modelType, options: []}
    },
    showEditCustomFieldModal (item) {
      this.customFieldItemEdit = this.$clone(item)
    },
    hideCustomFieldModal () {
      this.customFieldItemEdit = false
    },
    /*
    onGroupSortUpdate
    */
    onGroupSortUpdate (items) {
      this.loading = true

      Promise.all(items.map((item, pos) => {
        return this.$store
        .dispatch('updateCustomFieldGroup', {
          _id: item._id,
          position: pos
        })
      }))
      .then(() => {
        this.loading = false
      })
    },
    /*
    onCustomFieldSortUpdate
    */
    onCustomFieldSortUpdate (items) {
      this.loading = true

      Promise.all(items.map((item, pos) => {
        return this.$store
        .dispatch('updateCustomField', {
          _id: item._id,
          position: pos
        })
      }))
      .then(() => {
        this.loading = false
      })
    },
    changeModelType (type) {
      this.creating = true
      this.modelType = type
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CustomFields/CustomFields.vue